<template>
  <section class="app-transporte">
    <v-container fluid class="d-flex align-center justify-center">
      <Login />
    </v-container>
  </section>
</template>

<script>
import Login from './components/Login.vue';

export default {
  name: 'CPVIndex',
  components: { Login },
};
</script>
